// eslint-disable-next-line no-restricted-imports
import { usePaginatedList } from '../Provider'

import { SortSelect as SortSelectComponent, SortRow as SortRowComponent } from './Elements'

function convertSort(sortValue) {
  if (!sortValue) return sortValue
  const value = Array.isArray(sortValue) ? sortValue[0] : sortValue
  return `${Object.keys(value)[0]}:${Object.values(value)[0]}`
}

function formatSort(sortValue) {
  if (!sortValue) return sortValue
  const split = sortValue.split(':')
  return { [split[0]]: split[1] }
}

function useSort() {
  const { sort, setSort } = usePaginatedList()
  function onChangeSort(newValue) {
    setSort(formatSort(newValue))
  }
  return [convertSort(sort), onChangeSort]
}

function SortSelect({ className, items, light, disabled }) {
  const [value, onChangeSort] = useSort()
  const convertedItems = items.map(item => ({ ...item, value: convertSort(item.value) }))

  return (
    <SortSelectComponent
      className={className}
      value={value}
      onChange={onChangeSort}
      items={convertedItems}
      light={light}
      disabled={disabled}
    />
  )
}

function SortRow({ className, tableItems }) {
  const [value, onChangeSort] = useSort()
  const convertedItems = tableItems.map(item => ({ ...item, value: convertSort(item.value) }))
  return <SortRowComponent className={className} value={value} onChange={onChangeSort} tableItems={convertedItems} />
}

export const Sort = {
  Select: SortSelect,
  Row: SortRow,
}
